import { render, staticRenderFns } from "./WorldMapEN.vue?vue&type=template&id=319f0e75&scoped=true"
import script from "./WorldMapEN.vue?vue&type=script&lang=js"
export * from "./WorldMapEN.vue?vue&type=script&lang=js"
import style0 from "./WorldMapEN.vue?vue&type=style&index=0&id=319f0e75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319f0e75",
  null
  
)

export default component.exports